/**
 * Pillar definitions — matches the DEFAULT_DATA structure in the existing
 * q2-goals.html (around line 387), minus the `goals` array for now.
 *
 * When we port individual pillars in future sessions, each pillar's goals
 * will move into its own component file (src/pillars/XxxPillar.jsx), with
 * the goal data fetched from the same KV store the live dashboard uses.
 *
 * For now, this array drives the pillar tab navigation.
 */
export const PILLARS = [
  {
    id: 'eo-buyouts',
    name: 'EO Buyouts',
    icon: '🔄',
    color: '#ea580c',
    goalCount: 3,
  },
  {
    id: 'revenue',
    name: 'Revenue',
    icon: '💰',
    color: '#16a34a',
    goalCount: 1,
  },
  {
    id: 'growth',
    name: 'Growth',
    icon: '📈',
    color: '#2563eb',
    goalCount: 7,
  },
  {
    id: 'delivery',
    name: 'Delivery & Product',
    icon: '🚀',
    color: '#9333ea',
    goalCount: 8,
  },
  {
    id: 'team',
    name: 'Team & Culture',
    icon: '🤝',
    color: '#d97706',
    goalCount: 7,
  },
  {
    id: 'ai',
    name: 'AI Systems',
    icon: '🤖',
    color: '#0891b2',
    goalCount: 3,
  },
]

/**
 * Q2 2026 date boundaries — used by the countdown timer and progress bars.
 */
export const Q2_START = new Date('2026-04-01T00:00:00')
export const Q2_END = new Date('2026-07-01T00:00:00')
